import React, { FC } from "react"
import { Error } from "@bancacfplus/Error"
import { Heading } from "@bancacfplus/Heading"
import style from "./UserNotAllowed.module.scss"

export const UserNotAllowed: FC = () => {
  return (
    <div className={style.wrapper}>
      <Error>
        <div className={style.container}>
          <Heading as="h1" variant="h4">
            Utente non autorizzato
          </Heading>
          <p className={style.detail}>Non ci risulta che abbia accesso alla piattaforma clienti Banca CF+.</p>
          <p className={style.detail}>
            Se credi sia un errore, contattaci al{" "}
            <a className={style.link} href="tel:+39800938874">
              800938874
            </a>{" "}
            oppure scrivi una mail a{" "}
            <a className={style.link} href="mailto:customer.banking@bancacfplus.it">
              customer.banking@bancacfplus.it
            </a>
            .
          </p>
        </div>
      </Error>
    </div>
  )
}
